
import { supabase } from '@/integrations/supabase/client';
import { STORAGE_KEYS } from '../constants/storage-keys';
import { saveData } from './entry-save-service';

export const saveActiveFasting = (data: { startTime: string }): void => {
  saveData(STORAGE_KEYS.ACTIVE_FASTING, data);
};

export const getActiveFasting = (): { startTime: string } | null => {
  const data = localStorage.getItem(STORAGE_KEYS.ACTIVE_FASTING);
  return data ? JSON.parse(data) : null;
};

export const clearActiveFasting = async (): Promise<void> => {
  localStorage.removeItem(STORAGE_KEYS.ACTIVE_FASTING);
  const { data } = await supabase.auth.getSession();
  const userId = data.session?.user?.id;
  
  if (userId) {
    const { error } = await supabase
      .from('active_fasting')
      .delete()
      .eq('user_id', userId);
      
    if (error) {
      console.error('Error clearing active fasting from Supabase:', error);
      throw error;
    }
  }
};

export const saveActiveFastingToSupabase = async (data: { startTime: string }, userId: string): Promise<void> => {
  const { error } = await supabase
    .from('active_fasting')
    .upsert({
      user_id: userId,
      start_time: data.startTime,
      updated_at: new Date().toISOString()
    }, {
      onConflict: 'user_id'
    });
    
  if (error) {
    console.error('Error saving active fasting:', error);
    throw error;
  }
};
